<template>
  <div class="custom-icon-font iconfont" :class="iconName" :style="getStyleObject"></div>
</template>
<script setup lang="ts">
import { pxToVwCss, adaptStyle, filterObjectUndefined } from '@/utils/tools'
import { computed } from 'vue'
const props = withDefaults(
  defineProps<{
    iconName?: string
    size?: number | string
    color?: string
  }>(),
  {
    iconName: 'icon-lock',
    size: '14px',
    color: '#999'
  }
)

const getStyleObject = computed(() => {
  let style: { [key: string]: any } = { color: props.color, fontSize: props.size }
  return adaptStyle(style)
  // return filterObjectUndefined(style)
})
</script>
<style lang="scss" scoped></style>
